import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
import localStorageUtils from '@/utils/localStorage.utils';

Vue.use(Router);



const router = new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'Layout' },
    },
    {
      path: '/',
      name: 'Layout',
      redirect: { name: 'Home' },
      component: () => import('../views/layout'),
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('../views/home')
        },
        {
          path: 'shop-category',
          name: 'ShopCategory',
          component: () => import('../views/shop/category')
        },
        {
          path: 'shop-goods',
          name: 'ShopGoods',
          component: () => import('../views/shop/goods')
        },
        {
          path: 'shop-orders-unpay',
          name: 'ShopOrdersUnpay',
          component: () => import('../views/shop/orders/unpay')
        },
        {
          path: 'shop-orders-pay',
          name: 'ShopOrdersPay',
          component: () => import('../views/shop/orders/pay')
        },
        {
          path: 'shop-orders-unsign',
          name: 'ShopOrdersUnsign',
          component: () => import('../views/shop/orders/unsign')
        },
        {
          path: 'shop-orders-sign',
          name: 'ShopOrdersSign',
          component: () => import('../views/shop/orders/sign')
        },
        {
          path: 'shop-orders-refund',
          name: 'ShopOrdersRefund',
          component: () => import('../views/shop/orders/refund')
        },
        {
          path: 'member-info',
          name: 'MemberInfo',
          component: () => import('../views/member/info')
        },
        {
          path: 'money-record',
          name: 'MoneyRecord',
          component: () => import('../views/money/record')
        },
        {
          path: 'score-goods',
          name: 'ScoreGoods',
          component: () => import('../views/score/goods')
        },
        {
          path: 'score-orders-unsign',
          name: 'ScoreOrdersUnsign',
          component: () => import('../views/score/orders/unsign')
        },
        {
          path: 'score-orders-sign',
          name: 'ScoreOrdersSign',
          component: () => import('../views/score/orders/sign')
        },
        {
          path: 'score-orders-refund',
          name: 'ScoreOrdersRefund',
          component: () => import('../views/score/orders/refund')
        },
        {
          path: 'score-record',
          name: 'ScoreRecord',
          component: () => import('../views/score/record')
        },
        {
          path: 'system-user',
          name: 'SystemUser',
          component: () => import('../views/system/user')
        },
        {
          path: 'system-point',
          name: 'SystemPoint',
          component: () => import('../views/system/point')
        },
        {
          path: 'system-banner',
          name: 'SystemBanner',
          component: () => import('../views/system/banner')
        }
      ]
    }, {
      path: '/login',
      name: 'Login',
      component: () => import('../views/login')
    }
  ]
});


// 注册全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    next();
  } else {
    // 判断是否有token
    let token = localStorageUtils.getToken();
    if (token) {
      next();
    } else {
      Message({
        showClose: true,
        message: '请先登录系统',
        type: 'error',
        duration: 2000
      });
      next('/login');
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js